import React from 'react'
import { Button, Spacer, Text, View } from 'oio-react'
import { useParams, useRouteMatch } from 'react-router-dom'
import ProfileMoreButton from 'src/apps/Profile/components/MoreButton'
import { useUser } from 'src/graphql/hooks'

const ProfileAboutBlock = () => {
   const match = useRouteMatch()
   const { userId } = useParams()
   const { user } = useUser({ id: userId })

   const avatarUrl = user.avatarMedia
      ? user.avatarMedia?.file.thumbnailUrlW240
      : '/assets/images/avatarPlaceholder.svg'

   return (
      <>
         <View
            display="flex"
            flexFlow="row-reverse[a-c] column[d-f]"
            width="100%">
            <View
               flex="0 0 auto"
               width="70px[a-b] 90px[c-f]"
               height="70px[a-b] 90px[c-f]"
               marginBottom="20px[a-d] 30px[e-f]"
               borderRadius="50%"
               backgroundColor="#eee"
               backgroundImage={`url(${avatarUrl})`}
               backgroundSize={user.avatarMedia ? 'cover' : '90% 90%'}
               backgroundPosition="bottom center"
               backgroundRepeat="no-repeat"
            />
            <View
               flex="1 1 auto"
               width="100%"
               paddingRight="20px[a-c]">
               <Text size="8[a-b] 9[c-f]" weight="medium" color="#000">
                  {user.fullName}
               </Text>
               <Spacer size="0[a-b] 1[c-f]" />
               <Text size="3[a-d] 4[e-f]" color="#777">
                  {user.position}
                  {user.position && user.organization && ', '}
                  {user.organization}
               </Text>
               {user.bio && (
                  <View maxWidth="650px" marginTop="20px[a-d] 30px[e-f]">
                     <Text size="3" color="#555" lineHeight="140%">
                        {user.bio}
                     </Text>
                  </View>
               )}
            </View>
         </View>
         {user.skills.length > 0 && (
            <View
               width="100%"
               marginTop="20px[a-d] 30px[e-f]"
               paddingTop="20px[a-d] 30px[e-f]"
               borderTop="1px solid #ececec">
               <Text
                  size="2[a-b] 3[c-f]"
                  weight="medium"
                  color="#333">
                  Skills
               </Text>
               <View maxWidth="650px" marginTop="10px">
                  {user.skills.map(skill => (
                     <View
                        key={skill}
                        display="inline-flex"
                        alignItems="center"
                        height="25px"
                        padding="0px 10px"
                        borderRadius="2px"
                        marginRight="10px"
                        marginBottom="10px"
                        backgroundColor="#eee">
                        <Text size="2" color="#888">{skill}</Text>
                     </View>
                  ))}
               </View>
            </View>
         )}
         {user.certifications.length > 0 && (
            <View
               width="100%"
               marginTop="20px[a-d] 30px[e-f]"
               paddingTop={user.skills.length === 0 && '20px[a-d] 30px[e-f]'}
               borderTop={user.skills.length === 0 && '1px solid #ececec'}>
               <Text
                  size="2[a-d] 3[e-f]"
                  weight="medium"
                  color="#333">
                  Certifications
               </Text>
               <View maxWidth="650px" marginTop="10px">
                  {user.certifications.map(certification => (
                     <View
                        key={certification}
                        display="inline-flex"
                        alignItems="center"
                        height="25px"
                        padding="0px 10px"
                        borderRadius="2px"
                        marginRight="10px"
                        marginBottom="10px"
                        backgroundColor="#eee">
                        <Text size="2" color="#888">{certification}</Text>
                     </View>
                  ))}
               </View>
            </View>
         )}
         <View display="flex" marginTop="40px">
            {userId === 'me' && (
               <>
                  <Button
                     linkTo={`${match.url}/settings`}
                     width="120px"
                     size="md"
                     name="Edit Profile"
                     color="#e5e5e5"
                     textColor="#333"
                  />
                  <Spacer size="1" orientation="vertical" />
                  <Button
                     linkTo="/account/logout"
                     width="120px"
                     size="md"
                     name="Logout"
                     color="#e5e5e5"
                     textColor="#333"
                  />
                  <Spacer size="1" orientation="vertical" />
               </>
            )}
            <ProfileMoreButton />
         </View>
      </>
   )
}

export default ProfileAboutBlock
